// PS-1e — one quick-action set for the project masthead and the My Desk tiles.
// `run(projectId, navigate, handlers)`: a surface passes the handlers it owns
// (the masthead's four buttons); without one the action navigates.
import { HardHat, ScanLine, DollarSign, PenLine, ClipboardCheck, Mic, Layers, Users, Camera, ListChecks } from 'lucide-react';

const callOr = (handlers, key, fallback) => (handlers && handlers[key] ? handlers[key]() : fallback());

export const QUICK_ACTIONS = [
  { id: 'site-visit', label: 'Site visit', icon: HardHat,
    run: (projectId, navigate, h) => callOr(h, 'site-visit', () => navigate(`/quick/site-visit/${projectId}`)) },
  { id: 'scan', label: 'Scan', icon: ScanLine,
    run: (projectId, navigate, h) => callOr(h, 'scan', () => navigate(`/projects/${projectId}/desk?open=scans`)) },
  { id: 'expense', label: 'Expense', icon: DollarSign,
    run: (projectId, navigate, h) => callOr(h, 'expense', () => navigate(`/projects/${projectId}/purchases`)) },
  { id: 'memo', label: 'Memo', icon: PenLine,
    run: (projectId, navigate, h) => callOr(h, 'memo', () => navigate(`/projects/${projectId}/desk`)) },
  { id: 'punch-item', label: 'Punch item', icon: ClipboardCheck,
    run: (projectId, navigate) => navigate(`/projects/${projectId}/punch-list`) },
  { id: 'meeting', label: 'Meeting', icon: Mic,
    run: (projectId, navigate) => navigate(`/projects/${projectId}/desk?tab=meetings`) },
  { id: 'plans', label: 'Plans', icon: Layers,
    run: (projectId, navigate) => navigate(`/projects/${projectId}/drawings`) },
  { id: 'contacts', label: 'Contacts', icon: Users, noProject: true,
    run: (projectId, navigate) => (projectId ? navigate(`/quick/contacts?project=${projectId}`) : navigate('/quick/contacts')) },
  { id: 'clip', label: 'Clip', icon: Camera, noProject: true,
    run: (projectId, navigate) => (projectId ? navigate(`/quick/clip?project=${projectId}`) : navigate('/quick/clip')) },
];

// PS-3h — the tenth quick action. Not a tile (the nine stay nine): the My Desk bar under the tiles uses it.
export const LISTS_ACTION = { id: 'lists', label: 'Lists', icon: ListChecks, noProject: true,
  run: (projectId, navigate) => navigate('/quick/lists') };
